var currentTs = Date.now() / 1000;
export var isNewPerk = function (activationTimeString, isManuallyFirst) {
    if (isManuallyFirst === void 0) { isManuallyFirst = false; }
    var activationTime = new Date(activationTimeString);
    var twoWeekInTs = 1209600;
    var tsTwoWeeksAgo = currentTs - twoWeekInTs;
    return isManuallyFirst || tsTwoWeeksAgo <= activationTime.getTime() / 1000;
};
export { fallbackImage } from '../../../../images';
